import GATSBY_COMPILED_MDX from "/vercel/path0/content/case-studies/flagsmith/index.md";
import {graphql} from 'gatsby';
import React from 'react';
import Content from 'components/pages/case-study/content';
import Keynotes from 'components/pages/case-study/keynotes';
import Blog from 'components/shared/blog';
import CaseStudies from 'components/shared/case-studies';
import CTA from 'components/shared/cta';
import Layout from 'components/shared/layout';
import SEO from 'components/shared/seo/seo';
import SEO_DATA from 'constants/seo-data';
const CaseStudyTemplate = ({data: {mdx: {fields: {slug}, frontmatter, githubStars}}, children}) => {
  const content = {
    logo: frontmatter.logo,
    title: frontmatter.title,
    description: frontmatter.description,
    websiteUrl: frontmatter.websiteUrl,
    githubUsername: frontmatter.githubUsername,
    githubRepoName: frontmatter.githubRepoName,
    quote: frontmatter.quote,
    text: children,
    services: frontmatter.services,
    stack: frontmatter.stack,
    githubStars
  };
  return React.createElement(Layout, {
    headerTheme: "white"
  }, React.createElement(Content, content), React.createElement(Keynotes, {
    items: frontmatter.keynotes,
    iconsName: slug
  }), React.createElement(CaseStudies, {
    title: "We provided design & development services for many more projects.",
    activeItemSlug: slug
  }), React.createElement(Blog), React.createElement(CTA, {
    withTopMargin: true
  }));
};
export const query = graphql`
  query ($id: String!) {
    mdx(id: { eq: $id }) {
      fields {
        slug
      }
      frontmatter {
        logo {
          url {
            publicURL
          }
          width
          height
        }
        title
        description
        websiteUrl
        githubUsername
        githubRepoName
        quote {
          text
          authorName
          authorPosition
          authorPhoto {
            childImageSharp {
              gatsbyImageData(layout: FIXED, width: 48)
            }
          }
        }
        services
        stack
        keynotes
      }
      githubStars
    }
  }
`;
CaseStudyTemplate
export default function GatsbyMDXWrapper(props) {
  return React.createElement(CaseStudyTemplate, props, React.createElement(GATSBY_COMPILED_MDX, props));
}
export const Head = ({data: {mdx: {frontmatter: {title, description}}}}) => React.createElement(SEO, SEO_DATA.caseStudy({
  title,
  description
}));
